import React, { useState, useEffect, useMemo } from 'react';
import HeaderComponent from '../modules/Shared/components/HeaderComponent';
import ModalAddBuilderComponent from '../modules/Shared/modals/ModalAddBuilderComponent';
import ModalAddPending from '../modules/Shared/modals/ModalAddPending';
import { Table, Button, Form, Select, message } from 'antd';
import { PlusOutlined, ArrowLeftOutlined, EditOutlined } from '@ant-design/icons';
import axios from "./../services/http";
import { useNavigate } from 'react-router-dom';
const { Option } = Select;

const PendientesRelacionar = ({ obra }) => {

    const [loading, setLoading] = useState(true);
    const [pendienteList, setPendienteList] = useState([]);
    const [openDialogContratista, setOpenDialogContratista] = useState(false);
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [contratistas, setContratistas] = useState([]);
    const numberFormat = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 });

    {/** VARS MODAL ADD/EDIT PENDING **/ }
    const [openPendingDialog, setPendingDialog] = useState(false);
    const [editBand, setEditBand] = useState("create");
    const [pendingForRelationship, setPendingForRelationship] = useState();

    const totalsRel = useMemo(() => {
        let sumTotal = 0, sumContratoF = 0, sumContratoNF = 0;
        let sumRegF = 0, sumRegNF = 0, sumRestF = 0, sumRestNF = 0, sumTotalRest = 0;
        pendienteList.forEach((p) => {
            sumTotal += p.total || 0;
            sumContratoF += p.contratoFiscal || 0;
            sumContratoNF += p.contratoNoFiscal || 0;
            sumRegF += p.registradoFiscal || 0;
            sumRegNF += p.registradoNoFiscal || 0;
            let rF = (p.contratoFiscal || 0) - (p.registradoFiscal || 0);
            let rNF = (p.contratoNoFiscal || 0) - (p.registradoNoFiscal || 0);
            sumRestF += rF;
            sumRestNF += rNF;
            sumTotalRest += rF + rNF;
        });
        return { sumTotal, sumContratoF, sumContratoNF, sumRegF, sumRegNF, sumRestF, sumRestNF, sumTotalRest };
    }, [pendienteList]);

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id_pendiente',
            key: 'id_pendiente',
            fixed: 'left',
        },
        {
            title: 'Concepto',
            dataIndex: 'concepto',
            key: 'concepto',
        },
        {
            title: 'Contratista',
            dataIndex: 'contratista',
            key: 'contratista',
        },
        {
            title: 'Total',
            dataIndex: 'total',
            key: 'total',
            render: (total) => `$ ${numberFormat.format(total)}`,
        },
        {
            title: 'IVA',
            dataIndex: 'iva',
            key: 'iva',
            render: (iva) => `${numberFormat.format(iva)}%`,
        },
        {
            title: 'Contrato Fiscal',
            dataIndex: 'contratoFiscal',
            key: 'contratoFiscal',
            render: (contratoFiscal) => `$ ${numberFormat.format(contratoFiscal)}`,
        },
        {
            title: 'Contrato No Fiscal',
            dataIndex: 'contratoNoFiscal',
            key: 'contratoNoFiscal',
            render: (contratoNoFiscal) => `$ ${numberFormat.format(contratoNoFiscal)}`,
        },
        {
            title: 'Registrado Fiscal',
            dataIndex: 'registradoFiscal',
            key: 'registradoFiscal',
            render: (registradoFiscal) => `$ ${numberFormat.format(registradoFiscal)}`,
        },
        {
            title: 'Registrado No Fiscal',
            dataIndex: 'registradoNoFiscal',
            key: 'registradoNoFiscal',
            render: (registradoNoFiscal) => `$ ${numberFormat.format(registradoNoFiscal)}`,
        },
        {
            title: 'Restante Fiscal',
            dataIndex: 'restanteFiscal',
            key: 'restanteFiscal',
            render: (_, payment) => {
                let restante = numberFormat.format((payment.contratoFiscal - payment.registradoFiscal));
                return <>$ {restante}</>
            }
        },
        {
            title: 'Restante No Fiscal',
            dataIndex: 'restanteNoFiscal',
            key: 'restanteNoFiscal',
            render: (_, payment) => {
                let restante = numberFormat.format((payment.contratoNoFiscal - payment.registradoNoFiscal));
                return <>$ {restante}</>
            }
        },
        {
            title: 'Total Restante',
            dataIndex: 'totalRestante',
            key: 'totalRestante',
            render: (_, payment) => {
                let restanteFiscal = payment.contratoFiscal - payment.registradoFiscal;
                let restanteNoFiscal = payment.contratoNoFiscal - payment.registradoNoFiscal;
                let restante = numberFormat.format(restanteFiscal + restanteNoFiscal);
                return <>$ {restante}</>
            }
        },
        {
            title: 'Acciones',
            dataIndex: 'actions',
            key: 'actions',
            render: ((_, payment) =>
                <>
                    <div style={{ textAlign: "center" }}>
                        <Button color="primary" variant="filled" onClick={() => EditarPendiente(payment)}>
                            <EditOutlined />
                        </Button>
                    </div>
                </>
            )
        }
    ];

    useEffect(() => {
        fetchContratistas();
        fetchPendientesPorRelacionar();
    }, [obra]);

    const fetchContratistas = async () => {
        setLoading(true);
        try {
            const response = await axios.HTTP_GET(`/api/v1/catalogs/contratistas/${obra.id}`);
            if (response) setContratistas(response);
        } catch (error) {
            console.error('Error al cargar los contratistas:', error);
            message.error('Error al cargar los contratistas');
        } finally {
            setLoading(false);
        }
    };

    const fetchPendientesPorRelacionar = async () => {
        setLoading(true);
        try {
            const response = await axios.HTTP_GET(`/api/v1/payments/pendingToRelationship/${obra.id}/${"PENDIENTE"}`);
            if (response) {
                setPendienteList(response);
            }
        } catch (e) {
            console.error('Error al obtener los pendientes por relacionar:', e);
            message.error('Error al obtener los pendientes por relacionar');
            setPendienteList([]);
        } finally {
            setLoading(false);
        }
    }

    const Navigate = (path, params) => {
        navigate(path, params);
    }

    {/** FUNCTIONS MODAL ADD/EDIT PENDING **/ }
    const cancelPendingDialog = () => {
        setPendingDialog(false);
        setEditBand();
        setPendingForRelationship();
    };

    const EditarPendiente = async (payment) => {
        setPendingDialog(true);
        setEditBand("update");
        setPendingForRelationship(payment);
    }

    {/** FUNCTIONS MODAL ADD BUILDER **/ }
    const cancelBuilderDialog = () => setOpenDialogContratista(false);
    const savedBuilder = (response) => {
        form.setFieldsValue({ contratistaId: response.data.id });
        setContratistas([...contratistas, response.data]);
    }

    return (
        <>
            <HeaderComponent title={`Pendientes de Relacionar - ${obra.nombre_obra}`} />
            <div style={{ width: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                <Button type="primary" shape="round"
                    style={{ "marginBottom": "15px" }}
                    onClick={() => { setPendingDialog(true); setEditBand("create"); }}
                >
                    <PlusOutlined /> Nuevo pendiente
                </Button>
            </div>

            <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', padding: '12px 16px', background: '#fafafa', border: '1px solid #f0f0f0', borderRadius: 4, marginBottom: 8, fontWeight: 'bold', fontSize: 13 }}>
                <span>TOTALES:</span>
                <span>Total: $ {numberFormat.format(totalsRel.sumTotal)}</span>
                <span>Contrato Fiscal: $ {numberFormat.format(totalsRel.sumContratoF)}</span>
                <span>Contrato No Fiscal: $ {numberFormat.format(totalsRel.sumContratoNF)}</span>
                <span>Reg. Fiscal: $ {numberFormat.format(totalsRel.sumRegF)}</span>
                <span>Reg. No Fiscal: $ {numberFormat.format(totalsRel.sumRegNF)}</span>
                <span>Rest. Fiscal: $ {numberFormat.format(totalsRel.sumRestF)}</span>
                <span>Rest. No Fiscal: $ {numberFormat.format(totalsRel.sumRestNF)}</span>
                <span>Total Restante: $ {numberFormat.format(totalsRel.sumTotalRest)}</span>
            </div>
            <div>
                <Table
                    dataSource={pendienteList}
                    columns={columns}
                    rowKey="id"
                    loading={loading}
                    pagination={false}
                    scroll={{
                        x: 'max-content',
                    }}
                />
            </div>

            {/** INIT MODAL ADD/EDIT PENDING **/}
            <ModalAddPending
                title={`${(editBand === "create" ? "Nuevo" : "Editar")} pendiente por relacionar`}
                obra={obra}
                builders={contratistas}
                openPendingDialog={openPendingDialog}
                cancelPendingDialog={cancelPendingDialog}
                editBand={editBand}
                setOpenDialogContratista={setOpenDialogContratista}
                fetchPPR={fetchPendientesPorRelacionar}
                pendingForRelationship={pendingForRelationship}
            />
            {/** INIT MODAL END PENDING **/}

            {/** INIT MODAL ADD BUILDER **/}
            <ModalAddBuilderComponent
                obra={obra}
                openDialogContratista={openDialogContratista}
                cancelBuilderDialog={cancelBuilderDialog}
                savedBuilder={savedBuilder}
            />
            {/** END MODAL ADD BUILDER **/}
        </>
    );
}

export default PendientesRelacionar;